/**
 * Planning Template JavaScript
 * Handles the process tabs functionality
 */

document.addEventListener("DOMContentLoaded", function () {
  initProcessTabs();
});

/**
 * Initialize the process tabs functionality
 */
function initProcessTabs() {
  const tabIcons = document.querySelectorAll(".pi-procces__icon--top");
  const tabData = document.querySelectorAll(".pi-procces__data");

  if (!tabIcons.length || !tabData.length) {
    return; // Exit if elements don't exist
  }

  // Function to reset all sub-tabs
  function resetAllSubTabs() {
    const allSubTabDetails = document.querySelectorAll('.pi-procces__data--details');
    const allSubTabIcons = document.querySelectorAll('.pi-procces__icon--sub-tabs');
    
    allSubTabDetails.forEach(function(detail) {
      detail.removeAttribute('open');
    });
    
    allSubTabIcons.forEach(function(icon) {
      icon.classList.remove('isActive');
    });
  }

  // Add click event listeners to each tab icon
  tabIcons.forEach((icon, index) => {
    icon.addEventListener("click", function () {
      // Remove active class from all icons and data sections
      tabIcons.forEach((tabIcon) => tabIcon.classList.remove("isActive"));
      tabData.forEach((data) => data.classList.remove("isActive"));
      
      // Reset all sub-tabs when changing main tabs
      resetAllSubTabs();

      // Add active class to clicked icon and corresponding data
      icon.classList.add("isActive");
      if (tabData[index]) {
        tabData[index].classList.add("isActive");
      }
    });

    // Add keyboard accessibility
    icon.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        icon.click();
      }
    });

    // Make icons focusable for accessibility
    if (!icon.hasAttribute("tabindex")) {
      icon.setAttribute("tabindex", "0");
    }
  });
}
